interface Props {
  title?: string;
  content?: CustomerServiceElement[];
}

export interface CustomerServiceElement {
  text: string;
  link?: string;
}

function CustomerService({ title, content }: Props) {
  return (
    <div className="flex flex-col">
      {title && (
        <h3 className="text-sm text-[#333333] mt-5 mb-2.5 font-bold tracking-[0.06em] uppercase">
          {title}
        </h3>
      )}
      {content && content.length > 0 && (
        <ul>
          {content.map((customerServiceElement) => (
            <li className="py-1.5 text-[#1A1A1A] text-sm tracking-[0.06em]">
              {customerServiceElement.link
                ? (
                  <b>
                    <a
                      className="text-[#1A1A1A] font-semibold text-sm tracking-[0.06em]"
                      href={customerServiceElement.link}
                    >
                      {customerServiceElement.text}
                    </a>
                  </b>
                )
                : <span>{customerServiceElement.text}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default CustomerService;
